import { RootState } from "../../../redux/store";

/**
 * Is the object search (rooms, venues, …) still running?
 *
 * ONE definition, because two surfaces answer this question and they have to
 * agree: the selection step decides whether to show its in-flow spinner, and
 * the page shell decides whether to suppress its own overlay. If those two
 * drift, the customer gets either two spinners stacked on each other or none
 * at all — which is exactly the pair of defects QA #2764 E10/E11 reported, and
 * the first fix for them spelled the predicate out in both files.
 *
 * Two signals, covering different moments:
 *
 * - `loader` is set by `fetchApartmentsFlow` / `fetchVenuesFlow` around the
 *   request itself, beside `apartmentsLoadStarted()`, and cleared on every
 *   exit path.
 * - `apartmentsSearchAnswered` covers the frame BEFORE that. The shell starts
 *   the search from a `useEffect`, which React runs after it paints, so a cold
 *   mount on the selection step gets one painted frame with `loader` still
 *   false and the list still `[]`. `[]` is indistinguishable from "nothing
 *   matched", so without this the empty state renders for that frame.
 */
export const selectObjectSearchPending = (state: RootState): boolean =>
  state.bookingCreation.loader || !state.apartment.apartmentsSearchAnswered;
